import { api } from "./client";

export async function getAlertEvents(params?: { acknowledged?: boolean; severity?: string; page?: number }) {
  const searchParams = new URLSearchParams();
  if (params?.acknowledged !== undefined) searchParams.set("acknowledged", String(params.acknowledged));
  if (params?.severity) searchParams.set("severity", params.severity);
  if (params?.page) searchParams.set("page", String(params.page));
  return api.get("alerts/events", { searchParams }).json<{ events: Record<string, unknown>[]; unacknowledgedCount: number }>();
}

export async function acknowledgeAlert(id: number) {
  return api.patch(`alerts/events/${id}/acknowledge`).json();
}

export async function getAlertRules() {
  return api.get("alerts/rules").json<{ rules: Record<string, unknown>[] }>();
}

export async function createAlertRule(data: { name: string; ruleType: string; config: Record<string, unknown>; companyId?: number }) {
  return api.post("alerts/rules", { json: data }).json();
}
